module.exports = __webpack_public_path__ + "static/media/image9.33170c9d.jpeg";